module.exports = __webpack_public_path__ + "static/img/bind_success.1e60bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bind_success.png
// module id = Ge4O
// module chunks = 1